<script setup lang="ts">
const store = useAppStore();
</script>

<template>
  <header class="px-3 py-1 w-full h-16 bg-white border-b border-slate-300 flex justify-between">
    <site-logo size="w-40" />
    <h1 class="text-base text-slate-900 font-medium self-center">
      {{ store.pageTitle }}
    </h1>
    <div class="flex gap-3 items-center">
      <nav-plants />
      <select-locale />
      <button-user-avatar />
    </div>
  </header>
</template>
